import { useMutation, useQuery, useQueryClient } from "react-query";
import { deleteCostCode, getCostCodes, getQboItems, updateCostCode } from "./costCodesApi";
import { CostCode } from "./costCode";

export const useCostCodes = () => {
  return useQuery({
    queryKey: ['cost-codes'], 
    queryFn: getCostCodes,
    refetchOnWindowFocus: false
  })
}

export const useCostCodesInvalidator = () => {
  const queryClient = useQueryClient()
  
  return {
    invalidate: () => queryClient.invalidateQueries('cost-codes')
  }
}

export const useUpdateCostCode = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateCostCode,
    onMutate: async (costCode: CostCode) => {
      queryClient.setQueryData(['cost-codes'], (oldData: any) => {
        return oldData.map((oldCostCode: any) => {
          if (oldCostCode.id === costCode.id) {
            return costCode;
          }
          return oldCostCode;
        });
      });
    },
    onSettled: () => queryClient.invalidateQueries('cost-codes')
  })
}

export const useQboItems = () => {
  return useQuery(['qbo-items'], getQboItems)
}

export const useDeleteCostCode = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteCostCode,
    onSettled: () => queryClient.invalidateQueries('cost-codes')
  })
}
